// extracted by mini-css-extract-plugin
export var container = "ControlSpacer-module--container--02722";